import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { Router } from '@angular/router'
import { PayGateResponse } from '@parkupp/core'

@Component({
    selector: 'paygate-request-page',
    templateUrl: './paygate-request.component.html',
    styleUrls: ['./paygate-request.component.scss'],
})
export class PaygateRequestComponent implements OnInit, AfterViewInit {
    @Input() payGateResponse: PayGateResponse
    @ViewChild('mpiRequestForm') mpiRequestForm: any

    cardRequestForm: FormGroup
    submitted = false
    payRequestId: any
    redirectUrl: any
    checksum: any
    paygateId: any

    constructor(private fb: FormBuilder, private router: Router) {}

    ngOnInit() {
        this.payRequestId = localStorage.getItem('payRequestId') as any // getting values from localstorage
        this.paygateId = localStorage.getItem('paygateId') as any
        this.redirectUrl = localStorage.getItem('redirectUrl') as any
        this.checksum = localStorage.getItem('checksum') as any

        this.cardRequestForm = this.fb.group({
            payRequestId: [this.payRequestId, Validators.required],
            paygateId: [this.paygateId, Validators.required],
            checksum: [this.checksum, Validators.required],
        })
        return
    }

    onSubmit() {
        this.submitted = true

        if (this.cardRequestForm.invalid) {
            console.log(this.cardRequestForm, 'invalid form')
            alert('Data is missing!!') // return if data in form is invalid
            return
        }

        localStorage.removeItem('payRequestId')
        localStorage.removeItem('paygateId')
        localStorage.removeItem('redirectUrl')
        localStorage.removeItem('checksum')
    }

    ngAfterViewInit(): void {
        this.mpiRequestForm.nativeElement.submit()
    }
}
